<template>
  <div class="details-spec-item" @click="handleClick">
    <span v-if="label" class="details-spec-item-label">{{ label }}</span>
    <div class="details-spec-item-text" :style="{justifyContent: !label ? 'space-between' : 'right'}">
      <span> {{ text }}</span>
      <van-icon class="details-spec-item-text-icon" name="arrow" color="#999" size="1rem" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String
    },
    text: {
      type: String
    }
  },
  methods: {
    handleClick() {
      this.$emit("click");
    }
  }
};
</script>

<style lang="scss" scoped>
.details-spec-item {
  margin-top: 0.9rem;
  display: flex;
  flex-direction: row;
  font-size: 0.9rem;

  .details-spec-item-label {
    color: #666;
    min-width: 4.5rem;
  }

  .details-spec-item-text {
    display: flex;
    flex-direction: row;
    justify-content: right;
    flex: 1;

    .details-spec-item-text-icon {
      margin-top: 0.15rem;
      margin-left: 0.2rem;
    }
  }
}
</style>
